module.exports = __webpack_public_path__ + "media/images/icons/screen_landing-d7236a791ef2c0a201e9b6a3c589105d.svg";